import store from "../store"

class Order {
  async _init() {
    store.dispatch("services/fetchCart")
    return true
  }
  get list() {
    return store.getters["services/cart"]
  }
  get template() {
    const { mac, ip, location, location_id } = __.device.get()
    const { name, surname, pms_id, id } = __.guest.get()
    return {
      action: "Shopping",
      room: location,
      room_id: location_id,
      guest_name: `${name} ${surname}`,
      guest_id: id,
      guest_pms: pms_id,
      mac: mac,
      ip: ip,
      items: this.list
    }
  }

  async add(item) {
    if (!_$.store.getItem("guest"))
      return _$.vue.$toast({ element: "top-end", content: _$.vue.$t("You can't order without check-in."), theme: "danger" })

    const item_ = {
      title: item.title,
      count: 1,
      code: item.id,
      price: item.price,
      catalog: item.main,
      endpoint: item.endpoint || null
    }

    if (item.action_type !== "product") return this.nonProduct(item_, item.action_type)

    const isExist = this.list.find(rec => rec.code === item_.code)
    if (isExist) {
      if (isExist.count >= 9) return
      isExist.count++
      store.commit("services/cart", this.list)
      return _$.vue.$toast({ element: "top-end", content: _$.vue.$t("Your cart has been updated."), theme: "success" })
    }

    store.commit("services/cart", item_)

    if (this.list.length === 1) {
      const res = await _$.vue.$toast({
        element: "basket",
        content: _$.vue.$t("cartAdded", [item.title]),
        confirmButton: _$.vue.$t("Continue Shopping"),
        cancelButton: _$.vue.$t("Checkout"),
        theme: "success"
      })
      if (res.isDenied) return _$.vue.$sideload("cart", "right")
    } else _$.vue.$toast({ element: "top-end", content: _$.vue.$t("cartAdded", [item.title]), theme: "success" })

    return true
  }
  remove(item) {
    const item_ = this.list.find(rec => rec.code === item)
    if (!item_) return

    store.commit("services/cart", _$.removeFromArray(this.list, item_))
    return true
  }
  clear() {
    store.commit("services/cart", [])
  }
  async nonProduct(item, action_type) {
    const action = _$.vue.$t(action_type.capitalize())

    const keepPrice = ["Vod", "Channel"].includes(action)
    const confirmMessage = keepPrice ? "nonProductConfirmBuy" : "nonProductConfirm"
    const successMessage = keepPrice ? "nonProductSuccessBuy" : "nonProductSuccess"

    const res = await _$.vue.$interact.confirm(
      null,
      _$.vue.$t(confirmMessage, [item.title, action, item.price, __.device.config("view_currency.view_currency")]),
      "right"
    )
    if (!res) return false

    if (!keepPrice) {
      delete item.count
      delete item.price
    }
    const payload = Object.assign(this.template, { items: [item], action })
    const send = await this.send(payload)
    if (!send) return false

    _$.vue.$toast({ element: "top-end", content: _$.vue.$t(successMessage, [item.title, action]), theme: "success" })

    return send
  }
  async send(payload) {
    return __.api.set.setCart(payload)
  }
}

export default new Order()
